import Http from '../services/http.service';

const System = {};
System.version = async () => (await Http.get().get(`${process.env.VUE_APP_API}/version`)).data;
System.up = async () => (await Http.get().get(`${process.env.VUE_APP_API}/up`)).data;
System.getMessageKey = async () => (await Http.get().get(`${process.env.VUE_APP_API}/1/message/key`)).data;
System.getMessageConfig = async () => (await Http.get().get(`${process.env.VUE_APP_API}/1/message/config`)).data;

export default System;
